import { useEffect, useState } from "react";
import { ShoppingCart, FileDown } from "lucide-react";
import { StatusBadge } from "../DashboardShell";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../ui/table";
import { toast } from "sonner";
import api, { eur, downloadFile } from "../../lib/api";

export default function OrdersPanel() {
  const [orders, setOrders] = useState([]);
  const [agents, setAgents] = useState([]);
  const [ordFilter, setOrdFilter] = useState({ status: "all", agent: "all", q: "", frm: "", to: "" });

  const load = async () => {
    const [o, a] = await Promise.all([api.get("/orders"), api.get("/agents")]);
    setOrders(o.data); setAgents(a.data);
  };
  useEffect(() => { load().catch(() => {}); }, []);

  const dl = async (url, fname) => {
    try { await downloadFile(url, fname); } catch { toast.error("Download non riuscito"); }
  };

  const setOrderStatus = async (id, status) => { await api.put(`/orders/${id}/status`, { status }); load(); };

  const filteredOrders = orders.filter((o) =>
    (ordFilter.status === "all" || o.status === ordFilter.status) &&
    (ordFilter.agent === "all" || o.agent_name === ordFilter.agent) &&
    (!ordFilter.q || (o.client_name || "").toLowerCase().includes(ordFilter.q.toLowerCase())) &&
    (!ordFilter.frm || (o.created_at || "").slice(0, 10) >= ordFilter.frm) &&
    (!ordFilter.to || (o.created_at || "").slice(0, 10) <= ordFilter.to)
  );

  return (
    <div data-testid="orders-panel">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <Button onClick={() => dl("/reports/orders.pdf", "report_ordini.pdf")} variant="outline" data-testid="download-orders-btn" className="rounded-full border-stone-300"><FileDown className="w-4 h-4 mr-2" />Report ordini PDF</Button>
        <Button onClick={() => dl(`/reports/orders.xlsx?status=${ordFilter.status}&agent=${encodeURIComponent(ordFilter.agent)}&q=${encodeURIComponent(ordFilter.q)}&frm=${ordFilter.frm}&to=${ordFilter.to}`, "report_ordini.xlsx")} variant="outline" data-testid="download-orders-xlsx-btn" className="rounded-full border-stone-300"><FileDown className="w-4 h-4 mr-2" />Ordini Excel</Button>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        <Input placeholder="Cerca cliente…" value={ordFilter.q} onChange={(e) => setOrdFilter({ ...ordFilter, q: e.target.value })} className="w-48" data-testid="orders-search-input" />
        <Select value={ordFilter.status} onValueChange={(v) => setOrdFilter({ ...ordFilter, status: v })}>
          <SelectTrigger className="w-40" data-testid="orders-status-filter"><SelectValue placeholder="Stato" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutti gli stati</SelectItem>
            <SelectItem value="in_attesa">In attesa</SelectItem>
            <SelectItem value="approvato">Approvato</SelectItem>
            <SelectItem value="consegnato">Consegnato</SelectItem>
            <SelectItem value="rifiutato">Rifiutato</SelectItem>
          </SelectContent>
        </Select>
        <Select value={ordFilter.agent} onValueChange={(v) => setOrdFilter({ ...ordFilter, agent: v })}>
          <SelectTrigger className="w-48" data-testid="orders-agent-filter"><SelectValue placeholder="Agente" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutti gli agenti</SelectItem>
            {agents.map((a) => <SelectItem key={a.id} value={a.name}>{a.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Input type="date" value={ordFilter.frm} onChange={(e) => setOrdFilter({ ...ordFilter, frm: e.target.value })} className="w-40" data-testid="orders-from-input" />
        <Input type="date" value={ordFilter.to} onChange={(e) => setOrdFilter({ ...ordFilter, to: e.target.value })} className="w-40" data-testid="orders-to-input" />
      </div>
      <div className="bg-white rounded-2xl border border-stone-200 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Agente</TableHead><TableHead>Cliente</TableHead><TableHead>Totale</TableHead><TableHead>Provvigione</TableHead><TableHead>Stato</TableHead><TableHead>Azione</TableHead></TableRow></TableHeader>
          <TableBody>
            {filteredOrders.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-stone-400 py-8">Nessun ordine</TableCell></TableRow>}
            {filteredOrders.map((o) => (
              <TableRow key={o.id} data-testid={`admin-order-${o.id}`}>
                <TableCell>{o.agent_name}</TableCell>
                <TableCell className="font-medium">{o.client_name}</TableCell>
                <TableCell className="font-mono">{eur(o.total)}</TableCell>
                <TableCell className="font-mono text-[#15803D]">{eur(o.commission_amount)} <span className="text-xs text-stone-400">({o.commission_rate}%)</span></TableCell>
                <TableCell><StatusBadge status={o.status} /></TableCell>
                <TableCell>
                  <Select value={o.status} onValueChange={(v) => setOrderStatus(o.id, v)}>
                    <SelectTrigger className="h-8 w-36" data-testid={`order-status-${o.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="in_attesa">In attesa</SelectItem>
                      <SelectItem value="approvato">Approvato</SelectItem>
                      <SelectItem value="consegnato">Consegnato</SelectItem>
                      <SelectItem value="rifiutato">Rifiutato</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
